import styled from 'styled-components';

import {getAlphaColor, getRem, gts} from '../../../../../../../../styles';
import {Clickable} from '../../../../../../../../uikit/Clickable';
import {Text} from '../../../../../../../../uikit/Text';
import {View} from '../../../../../../../../uikit/View';

export const Container = styled(Clickable)`
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${getAlphaColor('static.accent.trackers', 0.15)};
  border-radius: ${gts('borderRadius.la')};
`;

export const Row = styled(View)`
  align-items: flex-start;
`;

export const Weight = styled(Text).attrs({weight: 'bold'})`
  font-size: ${getRem(70)};
  line-height: ${getRem(70)};
`;

export const Unit = styled(Text).attrs({weight: 'bold'})`
  font-size: ${getRem(30)};
  line-height: ${getRem(30)};
`;
